import DotMenuPopover from './DotMenuPopover';

export type { MenuAlignment, MenuItems } from './DotMenuPopover';

export default DotMenuPopover;
